import React from 'react';
import orange from '@mui/material/colors/orange';
import { useAuthMethod, useAuthUser } from '@crema/hooks/AuthHooks';
import { Box, Typography } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Fonts } from '@crema/constants/AppEnums';
import { useNavigate } from 'react-router-dom';

type UserInfoProps = {
  color?: string;
};

const UserInfo: React.FC<UserInfoProps> = ({ color = 'text.secondary' }) => {
  const { logout } = useAuthMethod();
  const { user } = useAuthUser();
  console.log('user', user);
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const getUserAvatar = () => {
    if (user.email) {
      return user.email.charAt(0).toUpperCase();
    }
  };

  return (
    <>
      <Box
        onClick={handleClick}
        sx={{
          py: 3,
          px: 3,
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
        }}
        className="user-info-view"
      >
        <Box sx={{ py: 0.5 }}>
          {user.photoURL ? (
            <Avatar
              sx={{
                height: 40,
                width: 40,
                fontSize: 24,
                backgroundColor: orange[500],
              }}
              src={user.photoURL}
            />
          ) : (
            <Avatar
              sx={{
                height: 40,
                width: 40,
                fontSize: 24,
                backgroundColor: orange[500],
                pb: 1,
              }}
            >
              {getUserAvatar()}
            </Avatar>
          )}
        </Box>
        <Box
          sx={{
            ml: 4,
            color: color,
          }}
          className="user-info"
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Box
              sx={{
                mb: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                fontSize: 16,
                fontWeight: Fonts.MEDIUM,
                color: 'inherit',
              }}
              component="span"
            >
              {user.email}
            </Box>
            <Box
              sx={{
                ml: 3,
                color: 'inherit',
                display: 'flex',
              }}
            >
              <ExpandMoreIcon />
            </Box>
          </Box>
          {/* <Box
            sx={{
              mt: -0.5,
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              color: 'inherit',
            }}
          >
            System Manager
          </Box> */}
        </Box>
      </Box>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {/* <MenuItem
          onClick={() => {
            handleClose();
            navigate('/my-account');
          }}
        >
          My account
        </MenuItem> */}
        <Typography sx={{ px: 3, pb: 2 }}>{user.email}</Typography>
        {user.roles.includes('CSP_BUSINESS') ||
          user.roles.includes('CSP_TECHNICAL') ||
          user.roles.includes('CSP_ADMIN') ||
          user.roles.includes('CSP_READ_ONLY') ? (
          <Typography
            sx={{ px: 3, pb: 2 }}
          >{`CSP ID: ${user.cspUserId}`}</Typography>
        ) : null}
        <hr />

        {user.roles.includes('ENTERPRISE_ADMIN') && (
          <MenuItem>
            <a className="link"
              href={'https://checkout.sabrhub.com/p/login/14k291b13gjB6He5kk'}
              target="_blank"
              rel="noopener noreferrer">Billing</a>
          </MenuItem>)}

        {user.roles.includes('CSP_BUSINESS') && (
          <MenuItem
            onClick={() => {
              handleClose();
              navigate('/webex-settings');
            }}
          >
            Webex settings
          </MenuItem>
        )}
        <MenuItem onClick={logout}>Logout</MenuItem>
      </Menu>
    </>
  );
};

export default UserInfo;
